import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    ref: "searchExpand",
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.advanced ? 'search' : null
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "layout": "horizontal",
      "model": _vm.form,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    class: _vm.advanced ? null : 'fold'
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "md": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "表单名称",
      "prop": "formName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入表单名称"
    },
    model: {
      value: _vm.form.formName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "formName", $$v);
      },
      expression: "form.formName"
    }
  })], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onClicCopyMeList
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": _vm.cz
    }
  }, [_vm._v("重置")])], 1)])], 1)]), _c('a-card', {
    ref: "searchExpand",
    staticClass: "acard-class",
    attrs: {
      "title": "流程申请",
      "size": "small",
      "bordered": false
    }
  }, [_c('div', {
    staticClass: "process-application-container"
  }, [_c('div', {
    staticClass: "process-application-container-left"
  }, _vm._l(_vm.processApplyFormLists, function (item, index) {
    return _c('a', {
      key: item.cateId,
      class: _vm.valueIndex == index ? 'process-application-container-left-menu-click' : 'process-application-container-left-menu',
      on: {
        "click": function click($event) {
          return _vm.changeValueIndex(index, item.cateName);
        }
      }
    }, [_vm.valueIndex == index ? _c('a-icon', {
      style: {
        fontSize: '14px',
        color: '#1890ff',
        marginRight: '12px'
      },
      attrs: {
        "type": "environment"
      }
    }) : _c('div', {
      staticClass: "process-application-container-left-menu-color"
    }), _c('div', [_vm._v(_vm._s(item.cateName))])], 1);
  }), 0), _c('div', {
    staticClass: "process-application-container-right"
  }, _vm._l(_vm.processApplyFormLists, function (item) {
    return _c('div', {
      key: item.cateId,
      staticClass: "process-application-container-right-wapper",
      attrs: {
        "id": item.cateName
      }
    }, [_c('div', {
      staticClass: "process-application-container-right-title"
    }, [_c('div', {
      staticClass: "process-application-container-right-title-text"
    }, [_vm._v(" " + _vm._s(item.cateName) + " ")])]), _c('div', {
      staticClass: "process-application-container-right-main"
    }, _vm._l(item.childNode, function (childItem) {
      return _c('a', {
        key: childItem.formId,
        staticClass: "process-application-container-right-main-menu",
        on: {
          "click": function click($event) {
            return _vm.enterItem(childItem);
          }
        }
      }, [_c('a-icon', {
        style: {
          fontSize: '16px',
          marginRight: '5px'
        },
        attrs: {
          "type": "file-add"
        }
      }), _vm._v(" " + _vm._s(childItem.formName) + " ")], 1);
    }), 0)]);
  }), 0), _c('a-drawer', {
    attrs: {
      "title": _vm.formName,
      "width": 1000,
      "visible": _vm.visible,
      "body-style": {
        paddingBottom: '80px'
      },
      "destroyOnClose": "",
      "zIndex": 999
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('a-form-model', {
    ref: "addForm",
    attrs: {
      "model": _vm.formObject,
      "rules": _vm.rules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 14
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId"
    }
  }, [_c('a-cascader', {
    style: {
      width: '100%',
      textAlign: 'left'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.formObject.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObject.organPostId"
    }
  })], 1)], 1)], 1)], 1), _c('br'), _c('fm-generate-form', {
    ref: "generateForm",
    attrs: {
      "data": _vm.jsonData
    }
  }), _c('div', {
    style: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1
    }
  }, [_c('a-button', {
    style: {
      marginRight: '8px'
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _c('a-button', {
    style: {
      marginRight: '8px'
    },
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.saveDraft
    }
  }, [_vm._v(" 存为草稿 ")]), _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };